import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { CompanyInfo } from '../model/company.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  AbstractControl,
  ValidatorFn,
  ValidationErrors
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { ProjectInfo } from '../model/project.model';
import { LookupInfo } from '../model/lookup.model';
import { CompanyGroupInfo } from '../model/CompanyGroupInfo.model';
import { CompanyContactInfo } from '../model/CompanyContactInfo.model';
import { CompanyAddressInfo } from '../model/CompanyAddressInfo.model';
import { ProvinceInfo } from '../model/ProvinceInfo.model';
import { DistrictInfo } from '../model/DistrictInfo.model';
import { SubDistrictInfo } from '../model/SubDistrictInfo.model';
import { CountryInfo } from '../model/CountryInfo.model';
import { async } from '@angular/core/testing';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { ValidateService } from '../service/validate.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-company-management',
  templateUrl: './company-management.component.html',
  styleUrls: ['./company-management.component.css']
})
export class CompanyManagementComponent implements OnInit {
  /************************* Variables ************************** */
  form: FormGroup;
  formCompanyGroup: FormGroup;
  formCompanyContact: FormGroup;
  formCompanyAddress: FormGroup;
  public body: string;
  _EmpCode: string;
  _RoleCode: string;
  CompanyListPromise: Promise<CompanyInfo[]>
  CompanyList: CompanyInfo[] = [];
  CompanyListPromisereturn: Promise<CompanyInfo[]>[]
  IndustryList: LookupInfo[]
  CustomerTypeList: LookupInfo[]
  CustomerTypeFullList: LookupInfo[]
  sortOrderCompany: any = 'asc'

  txtSearchGroupCode: string = '';
  txtSearchGroupName: string = '';

  CompanyGroupListPromise: Promise<CompanyGroupInfo[]>
  CompanyGroupList: CompanyGroupInfo[] = [];
  CompanyGroupListPromisereturn: Promise<CompanyGroupInfo[]>[]
  totalItems: number = 0
  companyGroupCodeSend: string = '';
  companyGroupTypeCodeSend: string = '';

  CompanyGroupLisNoPaging: CompanyGroupInfo[] = [];

  CompanyContactList: CompanyContactInfo[] = [];
  hidCompanyContactCode: string
  hidCompanyContactID: number

  txtSearchCompanyName: string
  ddlSearchCustomerType: number | null = null
  noResultString: any //set value to this on search click, in case of one search field

  txtCompanyCode: string
  txtCompanyName: string
  txtCompanyContactName: string
  txtCompanyLink: string
  txtCompanyIndustry: string
  txtCompanyCustomerType: string
  txtCompanyDescription: string
  txtCompanyType: string
  ddlCompanyGroup: string
  CompanyEmail: string
  CompanyPhone: string
  CompanyFax: string
  CompanyPrefix: string

  txtCompanyContactName_Ins: string
  txtCompanyContactTel_Ins: string
  txtCompanyContactEmail_Ins: string
  txtCompanyContactFax_Ins: string

  txtCompanyGroupName: string
  txtCompanyGroupDesc: string
  CompanyGroupTypeCode: string
  txtCompanyGroupCode: string
  hidCompanyGroupID: number

  flagduplicate: boolean;
  IsDuplicateCode: boolean;
  hidCompanyId: number

  public currentPageNumber: number
  public currentPageNumberCompanyGroup: number = 1
  public currentPageNumberCompanyContact: number = 1
  public CompanyTotal: number
  public totalPages: number
  public totalPagesCompanyGroup: number
  public totalPagesCompanyContact: number
  public environment: number

  ProjectTotal: any
  isOnUpdate: boolean;
  isOnUpdateCompGroup: boolean;
  isOnUpdateContact: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  getreturn: Promise<string>;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';
  loading: boolean = false;

  FalgSelectedList = [
    { Code: 'Y', Name: 'Yes' },
    { Code: 'N', Name: 'No' }
  ];

  //Modal
  titlemodal: string;
  detailmodal: string;

  @ViewChild('chkAllComGroup', { static: false }) chkAllComGroup: ElementRef;
  @ViewChild('chkAllContact', { static: false }) chkAllContact: ElementRef;
  @ViewChild('chkAllAddress', { static: false }) chkAllAddress: ElementRef;
  /************************* End Variables ************************** */

  // Hide Show Company Section Variable
  isVisible: boolean = true;
  GroupNameSelected: string = '';
  isReadOnly: boolean = true;

  CompanyGroupTypeList: LookupInfo[] = [];
  DupCompanyGroupCodeList: CompanyGroupInfo[] = [];
  IstxtCompGroupVal: boolean = false;

  CompanyGroupTypeListInit: LookupInfo[] = [];

  // Company Address Part
  CompanyAddressList: CompanyAddressInfo[] = [];
  ProvinceList: ProvinceInfo[] = [];
  DistrictList: DistrictInfo[] = [];
  SubDistrictList: SubDistrictInfo[] = [];
  CountryList: CountryInfo[] = [];

  hidCompanyIDForAddress: number;
  hidCompanyAddressID: number;
  isCompAddressOnUpdate: boolean = false;
  currentPageNumberCompanyAddress: number = 1;
  totalPagesCompanyAddress: number
  // Company Address Part


  // ตัวแปรสำหรับ autocomplete
  searchCompanyGroupText: string = '';
  showCompanyGroupDropdown = false;
  filteredCompanyGroupList: any[] = [];

  CompanyCheckDupList: CompanyInfo[] = [];
  isShowCompanyCode: boolean = false; // Flag show control company code
  isShowDisableGroupType: boolean = false;
  isShowDisableGroupTypeCustomer: boolean = false;

  viewfromcompgroupclick: string = '';

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private TokenService: TokenService, private GlobalService: GlobalService, private cdRef: ChangeDetectorRef, private validateService: ValidateService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit() {
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");

    this.form = this.formBuilder.group({
      txtCompanyCode: [null, Validators.required],
      txtCompanyName: [null, Validators.required],
      txtCompanyContactName: [null],
      txtCompanyLink: [null],
      txtCompanyIndustry: [null],
      txtCompanyCustomerType: [null, Validators.required],
      txtCompanyType: [null],
      txtCompanyDescription: [null],
      ddlCompanyGroup: [null, Validators.required],
      CompanyDisplayReportFlag: ['Y'],
      CompanyCountryDialCode: [null],
      CompanyEmail: [null],
      CompanyPhone: [null],
      CompanyFax: [null],
      CompanyPrefix: [null, Validators.required]
    });

    this.formCompanyGroup = this.formBuilder.group({
      txtCompanyGroupName: [null, Validators.required],
      txtCompanyGroupDesc: [null],
      CompanyGroupTypeCode: [null],
      txtCompanyGroupCode: [null]
    });

    
    

    this.formCompanyContact = this.formBuilder.group({
      txtCompanyContactName: [null, Validators.required],
      txtCompanyContactTel: [null, Validators.required],
      txtCompanyContactEmail: [null],
      txtCompanyContactFax: [null]
    });

    this.formCompanyAddress = this.formBuilder.group({
      CompanyAddress: [null, Validators.required],
      CompanyProvinceCode: [null, Validators.required],
      CompanyDistrictCode: [null, Validators.required],
      CompanySubDistrictCode: [null, Validators.required],
      CompanyPostCode: [null, Validators.required],
      CompanyCountryCode: [null, Validators.required]
    });

    this.formCompanyGroup.get('CompanyGroupTypeCode')?.valueChanges.subscribe(code => {
    const codeControl = this.formCompanyGroup.get('txtCompanyGroupCode');

    if (code === '1') {
      this.IstxtCompGroupVal = false;
      codeControl?.setValidators([Validators.required]);
    } else {
      this.IstxtCompGroupVal = true;
      codeControl?.clearValidators();
    }

      codeControl?.updateValueAndValidity(); // สำคัญ! บังคับให้ฟอร์มรีตรวจสอบใหม่
    });

    this.formCompanyAddress.get('CompanyProvinceCode')?.valueChanges.subscribe(async provincecode => {
      //console.log('CompanyProvinceCode value:', provincecode);
      //await this.LoadDistrictList(provincecode);
      if (provincecode) {
    // ถ้า provincecode มีค่า (ไม่เป็น null)
    //console.log('Loading districts for province:', provincecode);
    await this.LoadDistrictList(provincecode);
  } else {
    // ถ้า provincecode เป็น null (เช่น เลือก "Please Select" หรือค่าถูกรีเซ็ต)

    //console.log('CompanyProvinceCode is null. Clearing dependent lists and values.');

    // 1. เคลียร์รายการอำเภอ
    this.DistrictList = [];
    //console.log('DistrictList cleared.');

    // 2. รีเซ็ตค่าของ CompanyDistrictCode ในฟอร์ม
    this.formCompanyAddress.get('CompanyDistrictCode')?.patchValue(null);
    //console.log('CompanyDistrictCode reset to null.');

    // 3. เคลียร์รายการตำบล
    this.SubDistrictList = [];
    //console.log('SubDistrictList cleared.');

    // 4. รีเซ็ตค่าของ CompanySubDistrictCode ในฟอร์ม
    this.formCompanyAddress.get('CompanySubDistrictCode')?.patchValue(null); // สมมติว่ามี FormControl ชื่อ CompanySubDistrictCode
    //console.log('CompanySubDistrictCode reset to null.');

    // 5. รีเซ็ตค่าของ CompanyPostCode ในฟอร์ม
    this.formCompanyAddress.get('CompanyPostCode')?.patchValue(null); // สมมติว่ามี FormControl ชื่อ CompanyPostCode
    //console.log('CompanyPostCode reset to null.');
  }
    });

    this.formCompanyAddress.get('CompanyDistrictCode')?.valueChanges.subscribe(async districtcode => {
      //console.log('CompanyDistrictCode value:', districtcode);
      //await this.LoadSubDistrictList(districtcode);

      if (districtcode) {
    // ถ้า districtcode มีค่า (ไม่ใช่ null) ให้โหลดรายการตำบล
    console.log('Loading sub-districts for district:', districtcode);
    await this.LoadSubDistrictList(districtcode);
  } else {
    // ถ้า districtcode เป็น null (เช่น ผู้ใช้เลือก "Please Select" หรือค่าถูกรีเซ็ต)

    //console.log('CompanyDistrictCode is null. Clearing dependent lists and values.');

    // 1. เคลียร์รายการตำบล
    this.SubDistrictList = [];
    //console.log('SubDistrictList cleared.');

    // 2. รีเซ็ตค่าของ CompanySubDistrictCode ในฟอร์ม
    this.formCompanyAddress.get('CompanySubDistrictCode')?.patchValue(null);
    //console.log('CompanySubDistrictCode reset to null.');

    // 3. รีเซ็ตค่าของ CompanyPostCode ในฟอร์ม (หากผูกกับตำบล)
    this.formCompanyAddress.get('CompanyPostCode')?.patchValue(null);
    //console.log('CompanyPostCode reset to null.');
  }
    });
    
    this.form.get('CompanyCountryDialCode')?.valueChanges.subscribe(async dialcode => {
      //console.log('CompanyDistrictCode value:', districtcode);
      if (dialcode) {
        this.form.get('CompanyPhone')?.setValue(dialcode);
      }
    });

    this.currentPageNumber = 1;
    this.currentPageNumberCompanyGroup = 1;
    this.txtCompanyCode = "";
    this.txtCompanyName = "";
    this.txtCompanyContactName = "";
    this.txtCompanyLink = "";
    this.txtCompanyIndustry = "";
    this.txtCompanyCustomerType = "";
    this.txtCompanyType = "";
    this.txtCompanyDescription = "";
    this.ddlCompanyGroup = "";

    this.CompanyGroupTypeListInit = [
  {
    Id: 53,
    LookupCode: "1",
    LookupType: "COMPANYCUSTOMERTPYE",
    LookupValue: "Lead",
    CreateDate: "2021-06-21T13:18:17.85",
    CreateBy: null,
    CreateByFullName: " ",
    UpdateDate: "2021-06-24T11:20:34.897",
    UpdateBy: null,
    UpdateByFullName: " ",
    FlagDelete: "N         ",
    LookupDesc: null, 
    countLookup: 0,
    rowOFFSet: 0,
    rowFetch: 0
  },
  {
    Id: 54,
    LookupCode: "2",
    LookupType: "COMPANYCUSTOMERTPYE",
    LookupValue: "Prospect",
    CreateDate: "2021-06-21T13:18:23.993",
    CreateBy: null,
    CreateByFullName: " ",
    UpdateDate: "2021-06-24T11:20:39.81",
    UpdateBy: null,
    UpdateByFullName: " ",
    FlagDelete: "N         ",
    LookupDesc: null,
    countLookup: 0,
    rowOFFSet: 0,
    rowFetch: 0
  },
  {
    Id: 55,
    LookupCode: "3",
    LookupType: "COMPANYCUSTOMERTPYE",
    LookupValue: "Customer",
    CreateDate: "2021-06-21T13:18:28.137",
    CreateBy: null,
    CreateByFullName: " ",
    UpdateDate: "2021-06-24T11:20:49.54",
    UpdateBy: null,
    UpdateByFullName: " ",
    FlagDelete: "N         ",
    LookupDesc: null,
    countLookup: 0,
    rowOFFSet: 0,
    rowFetch: 0
  }
];

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadLookup('COMPANYINDUSTRY', auth_token).then((data) => {
        this.IndustryList = data;
      })
      this.loadLookup('COMPANYCUSTOMERTPYE', auth_token).then((data) => {
        this.CustomerTypeList = data;
        console.log('CompanyGroupTypeList', this.CustomerTypeList);
        //this.CompanyGroupTypeList = data.filter(x => x.LookupCode !== "2"); //CompanyGroupTypeListInit
        this.CompanyGroupTypeList = this.CompanyGroupTypeListInit.filter(x => x.LookupCode !== "2");
        
        if (this.CompanyGroupTypeList.length > 0) {
          setTimeout(() => {
          this.CompanyGroupTypeCode = this.CompanyGroupTypeList[0].LookupCode;
          this.cdRef.detectChanges();
          }, 100);
        }
      })
      //this.LoadCompany();
      //this.LoadCountCompanyList(auth_token);
      //this.OnLoadCountCompanyList(auth_token);

      this.LoadCompanyGroupList();
      this.LoadCompanyGroupListNoPaging();
      await this.LoadCompanyListNoPaging();
      await this.LoadProvinceList();
      await this.LoadCountryList();
    }

    this.formCompanyGroup.get('txtCompanyGroupCode')?.setValidators([this.companyGroupCodeValidator()]);
    this.formCompanyGroup.get('CompanyGroupTypeCode')?.valueChanges.subscribe(code => {
    const codeControl = this.formCompanyGroup.get('txtCompanyGroupCode');
    
    // อัพเดต validator ใหม่ทุกครั้งที่ CompanyGroupTypeCode เปลี่ยน
    codeControl?.setValidators([this.companyGroupCodeValidator()]);
    codeControl?.updateValueAndValidity();
  });

    this.OnUpdating('n');
    this.OnCreating('n')
  }

  //sort data being show
  sort(colName, order) {
    if (order == 'desc') {
      this.CompanyList.sort(alphabetically(false, colName));
      this.sortOrderCompany = 'asc';
    } else {
      this.CompanyList.sort(alphabetically(true, colName));
      this.sortOrderCompany = 'desc'
    }
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  ClearSearch() {
    this.currentPageNumber = 1;
    this.txtSearchCompanyName = "";
    this.ddlSearchCustomerType = null;
    this.noResultString = this.txtSearchCompanyName;
    // No need to implement as this.ddlSearchCustomerType
    this.LoadCompanyListV2();
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  async loadLookup(lookuptype: string, auth_token: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
      .toPromise()
  }


  btnClick_SearchCompanyList() {
    this.currentPageNumber = 1;
    this.noResultString = this.txtSearchCompanyName;
    // No need to implement as this.ddlSearchCustomerType
    this.LoadCompanyListV2();
  }

  async LoadCompany(viewfromcompgroup: string | null = null) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadCompanyList(auth_token, viewfromcompgroup)
        .then(
          data => {
            this.CompanyList = data
            this.hidcouchk = this.CompanyList.length.toString();
          }
        );
    }
  }
  LoadCompanyList(auth_token: string, viewfromcompgroup: string | null = null): Promise<CompanyInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumber - 1) * environment.PageSize;

    var objectjson = {};

    if (viewfromcompgroup === "Y") {
      // No use search field
    } else {
      objectjson['CompanyCustomerType'] = this.ddlSearchCustomerType;
      objectjson['CompanyName'] = this.checkUndefinedString(this.txtSearchCompanyName);
    }

    objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.companyGroupCodeSend);
    objectjson['CompanyFlagDelete'] = "N";
    objectjson['rowFetch'] = environment.PageSize;
    objectjson['rowOFFSet'] = offset;


    let strjson = JSON.stringify(objectjson);


    return this.httpClient.post<CompanyInfo[]>(this.baseurl + "company/GetCompany", strjson, httpOptions)
      .toPromise()
  }
  LoadCountCompanyList(auth_token: string, viewfromcompgroup: string | null = null) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    if (viewfromcompgroup === "Y") {
      // No use search field
    } else {
      objectjson['CompanyName'] = this.checkUndefinedString(this.txtSearchCompanyName);
      objectjson['CompanyCustomerType'] = this.ddlSearchCustomerType;
    }

    objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.companyGroupCodeSend);
    
    objectjson['CompanyFlagDelete'] = "N";

    let strjson = JSON.stringify(objectjson);
    return this.httpClient.post<number>(this.baseurl + "company/GetCountCompany", strjson, httpOptions)
      .toPromise();
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  async btnClick_submitInsertCompany() {

//     if (!this.ddlCompanyGroup && this.searchCompanyGroupText) {
//   const matchedGroup = this.CompanyGroupLisNoPaging.find(x =>
//     (x.CompanyGroupCode + ' - ' + x.CompanyGroupName).toLowerCase() ===
//     this.searchCompanyGroupText.trim().toLowerCase()
//   );
//   if (matchedGroup) {
//     this.ddlCompanyGroup = matchedGroup.CompanyGroupCode;
//   } else {
//     this.ddlCompanyGroup = null; // หรือแจ้งเตือนให้เลือกใหม่
//   }
// }
let isValidForSubmission = this.form.valid;

if (this.companyGroupTypeCodeSend !== '1' && this.flagduplicate === true) {
    isValidForSubmission = false; // ถ้าพบข้อมูลซ้ำในกรณีที่ต้องตรวจสอบ ให้ถือว่าไม่สามารถส่งฟอร์มได้
  }

    if (isValidForSubmission) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['CompanyCode'] = this.checkUndefinedString(this.txtCompanyCode);
        objectjson['CompanyName'] = this.checkUndefinedString(this.txtCompanyName);

        objectjson['CompanyAbbreviation'] = this.checkUndefinedString(this.txtCompanyCode);

        objectjson['CompanyContactName'] = this.checkUndefinedString(this.txtCompanyContactName);
        objectjson['CompanyLink'] = this.checkUndefinedString(this.txtCompanyLink);
        objectjson['CompanyIndustry'] = this.checkUndefinedString(this.txtCompanyIndustry).toString();
        objectjson['CompanyCustomerType'] = this.checkUndefinedString(this.txtCompanyCustomerType).toString();
        objectjson['CompanyType'] = this.checkUndefinedString(this.txtCompanyType).toString();
        objectjson['CompanyDescription'] = this.checkUndefinedString(this.txtCompanyDescription);
        //objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.ddlCompanyGroup); // this.checkUndefinedString(this.form.get('ddlCompanyGroup')?.value),
        objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.form.get('ddlCompanyGroup')?.value),
        objectjson['CompanyDisplayReportFlag'] = this.checkUndefinedString(this.form.get('CompanyDisplayReportFlag')?.value),
        objectjson['CompanyEmail'] = this.checkUndefinedString(this.form.get('CompanyEmail')?.value),
        objectjson['CompanyCountryDialCode'] = this.checkUndefinedString(this.form.get('CompanyCountryDialCode')?.value),
        objectjson['CompanyPhone'] = this.checkUndefinedString(this.form.get('CompanyPhone')?.value),
        objectjson['CompanyFax'] = this.checkUndefinedString(this.form.get('CompanyFax')?.value),
        objectjson['CompanyPrefix'] = this.checkUndefinedString(this.form.get('CompanyPrefix')?.value),
        objectjson['CompanyGroupTypeCode'] = this.checkUndefinedString(this.companyGroupTypeCodeSend);
        objectjson['CompanyCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['CompanyFlagDelete'] = "N";

        console.log('objectjson', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
        const result = this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/InsertCompany", strjson, httpOptions)
        .toPromise();

        this.isSubmitted = result;
          
          $('#ModalCompany').modal('hide');
          $('#ModalCreateComplate').modal();
          await this.LoadCompanyListV2("Y");
          await this.LoadCompanyListNoPaging();
          
          } catch (err) {
          console.error("Insert failed", err);
        } finally {
          this.OnCreating('n');
        }
          // .subscribe(result => this.isSubmitted = result, failCb => {
          //   console.log("Insert fail")
          //   this.OnCreating('n');
          // },
          //   () => {
          //     console.log("Insert = " + this.isSubmitted)
          //     this.OnCreating('n');
          //     $('#ModalCreateComplate').modal();
          //     await this.LoadCompanyListV2("Y");
          //     await this.LoadCompanyGroupListNoPaging();
          //     //this.LoadCompany();

          //   }
          // )

      }

    } else {
      this.validateAllFormFields(this.form);
    }

  }

  async btnClick_submitUpdateCompany(id) {
    let isValidForSubmission = this.form.valid;

if (this.companyGroupTypeCodeSend !== '1' && this.flagduplicate === true) {
    isValidForSubmission = false; // ถ้าพบข้อมูลซ้ำในกรณีที่ต้องตรวจสอบ ให้ถือว่าไม่สามารถส่งฟอร์มได้
  }


    if (isValidForSubmission) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');

        id = this.hidCompanyId
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`

          })
        };

        var objectjson = {};
        objectjson['CompanyId'] = id;
        objectjson['CompanyCode'] = this.checkUndefinedString(this.txtCompanyCode);
        objectjson['CompanyName'] = this.checkUndefinedString(this.txtCompanyName);
        objectjson['CompanyContactName'] = this.checkUndefinedString(this.txtCompanyContactName);
        objectjson['CompanyLink'] = this.checkUndefinedString(this.txtCompanyLink);
        objectjson['CompanyIndustry'] = this.checkUndefinedString(this.txtCompanyIndustry).toString();
        objectjson['CompanyCustomerType'] = this.checkUndefinedString(this.txtCompanyCustomerType).toString();
        objectjson['CompanyType'] = this.checkUndefinedString(this.txtCompanyType).toString();
        objectjson['CompanyDescription'] = this.checkUndefinedString(this.txtCompanyDescription);
        objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.ddlCompanyGroup);
        objectjson['CompanyDisplayReportFlag'] = this.checkUndefinedString(this.form.get('CompanyDisplayReportFlag')?.value),
        objectjson['CompanyEmail'] = this.checkUndefinedString(this.form.get('CompanyEmail')?.value),
        objectjson['CompanyCountryDialCode'] = this.checkUndefinedString(this.form.get('CompanyCountryDialCode')?.value),
        objectjson['CompanyPhone'] = this.checkUndefinedString(this.form.get('CompanyPhone')?.value),
        objectjson['CompanyFax'] = this.checkUndefinedString(this.form.get('CompanyFax')?.value),
        objectjson['CompanyPrefix'] = this.checkUndefinedString(this.form.get('CompanyPrefix')?.value),
        objectjson['CompanyUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);
        console.log('objectjson', objectjson);

        try {
        const result = this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/UpdateCompany", strjson, httpOptions)
        .toPromise();

        this.isSubmitted = result;

        $('#ModalCompany').modal('hide');
        await this.LoadCompanyListV2("Y");
        await this.LoadCompanyListNoPaging();
        $('#ModalUpdateComplate').modal();
        
        } catch (error) {
        console.error("Update failed", error);
      } finally {
        this.OnUpdating('n');
      }
      }
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  btnClick_deleteCompany(id, auth_token): Observable<CompanyInfo[]> {


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['CompanyId'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/DeleteCompany", strjsonCusInfo, httpOptions);
  }


  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxcompany"]').prop('checked', check);

  }

  async btnClick_deleteCompanyitem(id) {

    if (confirm("Are you sure you want to delete this Company ?")) {
      let checkCompCodeUsed = await this.CheckAlreadyUsedCompanyCode(id);
      if (!checkCompCodeUsed) {

        var currentCompany = this.CompanyList.filter(x => { return x.CompanyId == id });
        var isOwner = (currentCompany[0].CompanyCreateBy == this._EmpCode);

        //console.log(" Delete id = " + id + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
        if (isOwner || (this._RoleCode == "ADMIN")) {

          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {

            this.btnClick_deleteCompany(parseInt(id), auth_token).toPromise()
              .then(
                data => {
                  //console.log('หลังรับค่า');
                  $('#ModalDeleteComplate').modal('show');
                  this.LoadCompanyListV2("Y");
                  //this.LoadCompany();
                }
              );
          }
        } else
        {
          this.titlemodal = "Sorry"
          this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
          $('#ModalError .modal-header').text("Sorry");
          $('#ModalError .modal-header').addClass('bg-blue');
          $('#ModalError').modal();
        }
      }
    }

  }

  async btnClick_onDeleteCompanyList() {

    if (confirm("Are you sure to delete this Company?")) {

      var checkkedcompany = $('[name="checkboxcompany"]:checked');
      let num = checkkedcompany.length;
      let listCompanyModel = [];
      

      for (var i = 0; i < num; i++) {
        var Companycurrent = <HTMLInputElement>checkkedcompany[i];
        let companyInfo = new CompanyInfo;
        companyInfo.CompanyId = parseInt(Companycurrent.value);

        let checkCompCodeUsed = await this.CheckAlreadyUsedCompanyCode(parseInt(Companycurrent.value));
        if (!checkCompCodeUsed) {

          var currentCompany = this.CompanyList.filter(x => { return x.CompanyId == companyInfo.CompanyId });
          var isOwner = (currentCompany[0].CompanyCreateBy == this._EmpCode);

          console.log(" Delete id = " + companyInfo.CompanyId + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
          if (isOwner || (this._RoleCode == "ADMIN")) {
            listCompanyModel.push(companyInfo);
          } else
          {
            //this.titlemodal = ""
            //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
            this.detailmodal = "You don't have permission to delete this company. Please contact" + currentCompany[0].CompanyCreateByDisplay;
            $('#ModalError .modal-header').text("Information");
            $('#ModalError .modal-header').addClass('bg-blue');
            $('#ModalError').modal();

            listCompanyModel = [];
            break; //break loop
          }

        } else {
          //clear
          
          break;
        }
      }

      if (listCompanyModel.length > 0) {
        this.deleteListCompany(listCompanyModel)
      }

    }
  }

  async deleteListCompany(listCompanyModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
     

      let strjsonCusInfo = JSON.stringify(listCompanyModel);

      this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/DeleteListCompany", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(data => {
          console.log("delete company list successfully");
          $('#ModalDeleteComplate').modal('show');
          this.LoadCompany();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  btnClick_onCreateCompany() {
    $('#ModalCompany').modal('hide');

    setTimeout(() => {
    this.form.reset();
    this.OnCreating('n');
    //$('#txtCompanyCode').removeAttr('disabled');
    
    this.txtCompanyCode = "";
    this.txtCompanyName = "";
    this.txtCompanyContactName = "";
    this.txtCompanyLink = "";
    this.txtCompanyIndustry = "";
    //this.txtCompanyCustomerType = "";
    this.txtCompanyType = "";
    this.txtCompanyDescription = "";
    //this.ddlCompanyGroup = "";
    this.isOnUpdate = false;
    
    this.form.patchValue({ ddlCompanyGroup: this.companyGroupCodeSend });

    const selectedGroup = this.CompanyGroupLisNoPaging.find(x => x.CompanyGroupCode === this.companyGroupCodeSend);
    this.searchCompanyGroupText = selectedGroup ? 
                                  `${selectedGroup.CompanyGroupCode} - ${selectedGroup.CompanyGroupName}`
                                  : '';

    //console.log('this.companyGroupCodeSend', this.companyGroupCodeSend);
    //console.log('this.ddlCompanyGroup', this.ddlCompanyGroup)

    if (this.CustomerTypeList.length > 0) {
      console.log('this.companyGroupTypeCodeSend', this.companyGroupTypeCodeSend);

      if(this.companyGroupTypeCodeSend === '1') {
        //this.form.patchValue({ txtCompanyCode: this.companyGroupCodeSend });
        this.form.patchValue({ txtCompanyCustomerType: this.CustomerTypeList[0].Id });
      } else if (this.companyGroupTypeCodeSend === '3') {
        this.form.patchValue({ txtCompanyCustomerType: 55 });
      }
    }

    this.form.patchValue({CompanyDisplayReportFlag: 'Y'});
    //console.log('companyGroupCodeSend OnCreate', this.companyGroupCodeSend);
    //console.log('ddlCompanyGroup OnCreate', this.ddlCompanyGroup);

    if(this.CountryList.length > 0){
        const firstDialCode = this.CountryList[0].DialCode;
        this.form.patchValue({CompanyCountryDialCode: firstDialCode});
      }

    this.CustomerTypeFullList = this.CustomerTypeFullList; 
  if (this.companyGroupTypeCodeSend === "1") {
    // กรณีเป็น Lead
    this.CustomerTypeList = this.CustomerTypeFullList.filter(x => x.LookupCode === "1");
  } else {
    // กรณี Prospect หรือ Customer
    //this.CustomerTypeList = this.CustomerTypeFullList.filter(x => x.LookupCode === "2" || x.LookupCode === "3");
    this.CustomerTypeList = this.CustomerTypeFullList.filter(x => x.LookupCode === "1");

    // this.txtCompanyCustomerType = null;
    // this.form.patchValue({ txtCompanyCustomerType: null });
    // this.form.get('txtCompanyCustomerType')?.enable();
  }

    $('#ModalCompany').modal('show');
    }, 200);
  }

  CheckduplicateCompanyCode() {
    var CompanyCode = this.txtCompanyCode;
    var flagreturn = false;

    if (this.isOnUpdate == true) {
      if (!!this.CompanyCheckDupList && this.CompanyCheckDupList.length > 0) {
        //console.log('CompanyCheckDupList for Check Dup', this.CompanyCheckDupList);

        let found = this.CompanyCheckDupList.find(x => x.CompanyCode === CompanyCode);

        if (found && found.CompanyId !== this.hidCompanyId) {
          flagreturn = true;
        }
      }
      //return false;
    }
    else {
      if (!!this.CompanyCheckDupList && this.CompanyCheckDupList.length > 0) {
        //console.log('CompanyCheckDupList for Check Dup', this.CompanyCheckDupList);
        let index = this.CompanyCheckDupList.findIndex(x => x.CompanyCode == CompanyCode);
        //console.log('index', index);
      if (index != -1) {
        flagreturn = true;
        }
      }
    }
    
    this.flagduplicate = flagreturn;
    return flagreturn;
  }

  async CheckAlreadyUsedCompanyCode(companyId) {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`

        })
      };

      var objectjson = {};
      objectjson['CompanyId'] = companyId;
      objectjson['CompanyCode'] = this.txtCompanyCode;

      let strjson = JSON.stringify(objectjson);

      let result = await this.httpClient.post<any>(this.baseurl + "Company/CheckAlreadyUsedCompanyCode", strjson, httpOptions)
        .toPromise()
        .then(result => {
          if (result) {
            console.log("CheckAlreadyUsedCompanyCode = " + result);

            //Inform user
            this.titlemodal = '';
            this.detailmodal = 'Cannot delete company code. This company code is in use.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-blue');
            $('#ModalComplate').modal();
          }

          return result;
        })
        .catch(err => {
          console.log(err);
          return false;
        });

      return result;
    }
  }


  btnClick_onUpdateCompany(id) {
    //$('#txtCompanyCode').attr('disabled', 'disabled');
    $('#ModalCompany').modal('hide');
    this.isOnUpdate = true

    let index = this.CompanyList.findIndex(x => x.CompanyId == id);
    const company = this.CompanyList[index];

    this.txtCompanyCode = this.CompanyList[index].CompanyCode != null ? this.CompanyList[index].CompanyCode : null
    this.txtCompanyName = this.CompanyList[index].CompanyName != null ? this.CompanyList[index].CompanyName : null
    this.txtCompanyContactName = this.CompanyList[index].CompanyContactName != null ? this.CompanyList[index].CompanyContactName : null
    this.txtCompanyLink = this.CompanyList[index].CompanyLink != null ? this.CompanyList[index].CompanyLink : null

    const dialCode = company.CompanyCountryDialCode ?? null;
    let phone = company.CompanyPhone ?? null;
    
    // ตรวจสอบและเติม prefix
    if (dialCode && phone) {
      phone = phone.toString().trim();
      // ลบ prefix เก่าออกก่อน (ถ้ามี)
      if (phone.startsWith('+')) {
        phone = phone.replace(/^\+\d{1,3}/, '');
      }
      // เติม prefix ใหม่
      phone = dialCode + phone;
      
      console.log('📱 Phone formatted:', phone); // debug
    }

    this.form.patchValue({
      txtCompanyIndustry: this.CompanyList[index].CompanyIndustry != null ? parseInt(this.CompanyList[index].CompanyIndustry) : null,
      txtCompanyCustomerType: this.CompanyList[index].CompanyCustomerType != null ? parseInt(this.CompanyList[index].CompanyCustomerType) : null,
      txtCompanyType: this.CompanyList[index].CompanyType != null ? parseInt(this.CompanyList[index].CompanyType) : null,
      CompanyDisplayReportFlag: this.CompanyList[index].CompanyDisplayReportFlag != null ? this.CompanyList[index].CompanyDisplayReportFlag : null,
      CompanyEmail: this.CompanyList[index].CompanyEmail != null ? this.CompanyList[index].CompanyEmail : null,
      CompanyCountryDialCode: this.CompanyList[index].CompanyCountryDialCode != null ? this.CompanyList[index].CompanyCountryDialCode : null,
      //CompanyPhone: this.CompanyList[index].CompanyPhone != null ? this.CompanyList[index].CompanyPhone : null,
      CompanyPhone: phone,
      CompanyFax: this.CompanyList[index].CompanyFax != null ? this.CompanyList[index].CompanyFax : null,
      CompanyPrefix: this.CompanyList[index].CompanyPrefix != null ? this.CompanyList[index].CompanyPrefix : null
    });

    this.txtCompanyDescription = this.CompanyList[index].CompanyDescription != null ? this.CompanyList[index].CompanyDescription : null
    this.ddlCompanyGroup = this.CompanyList[index].CompanyGroupCode != null ? this.CompanyList[index].CompanyGroupCode : null
    this.hidCompanyId = this.CompanyList[index].CompanyId

    if (this.CustomerTypeList.length > 0) {
      this.CustomerTypeList = this.CustomerTypeFullList;
      const selectedCustomerType = this.form.get('txtCompanyCustomerType')?.value;
      //console.log('txtCompanyCustomerType', selectedCustomerType);
    if (selectedCustomerType === 55) {
      //console.log('txtCompanyCustomerType2', this.txtCompanyCustomerType);
      //this.CustomerTypeList = this.CustomerTypeFullList;
      this.CustomerTypeList = this.CustomerTypeList.filter(x => x.LookupCode === "3");
      } else if (selectedCustomerType === 53) {
      this.CustomerTypeList = this.CustomerTypeList.filter(x => x.LookupCode === "1");
      }
    }

    if (this.companyGroupTypeCodeSend === '3'){ // ใช้เหมือน GroupTypeCode === "1" คือ ไม่ต้อง Update ข้ามไปมา เพราะ จะใช้ StatusPipeLine ในการ Update
      //this.CustomerTypeList = this.CustomerTypeFullList;
      //this.CustomerTypeList = this.CustomerTypeList.filter(x => x.LookupCode === "1" || x.LookupCode === "3");
    }

    //console.log('txtCompanyCustomerType1', this.txtCompanyCustomerType);

    // if (parseInt(this.txtCompanyCustomerType) === 55) {
    //   this.form.get('txtCompanyCustomerType')?.disable();
    //   this.form.get('txtCompanyCustomerType')?.clearValidators(); // เพิ่มบรรทัดนี้
    //     this.form.get('txtCompanyCustomerType')?.setErrors(null);   // เพิ่มบรรทัดนี้
    //     this.form.get('txtCompanyCustomerType')?.updateValueAndValidity();
    // } else {
    //   this.form.get('txtCompanyCustomerType')?.enable();
    //   this.form.get('txtCompanyCustomerType')?.updateValueAndValidity();
    // }

    // Update ดึง Data Company Name โดยตัดที่มี [New] ต่อท้ายออก
    let rawName = this.txtCompanyName;

    if (rawName && rawName.endsWith(" [New]")) {
      this.txtCompanyName = rawName.substring(0, rawName.length - 6); // ตัด 6 ตัวอักษร: 1 space + [New]
    } else {
      this.txtCompanyName = rawName;
    }

    let selectedGroup = this.CompanyGroupLisNoPaging.find(
  x => x.CompanyGroupCode === this.ddlCompanyGroup
);
if (selectedGroup) {
  this.searchCompanyGroupText = `${selectedGroup.CompanyGroupCode} - ${selectedGroup.CompanyGroupName}`;
}

const ddlGroupControl = this.form.get('ddlCompanyGroup');
  if (ddlGroupControl) {
    ddlGroupControl.setValue(this.ddlCompanyGroup); // set ค่าใหม่
    ddlGroupControl.setErrors(null);                 // ล้าง error เดิม
    ddlGroupControl.markAsPristine();                // ทำให้เหมือนเพิ่งเริ่ม
    ddlGroupControl.markAsUntouched();
  }

    $('#ModalCompany').modal();

  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitcompany").hide();
      $("#txtCompanyCode").prop('disabled', true);
      $("#txtCompanyName").prop('disabled', true);
      $("#txtCompanyContactName").prop('disabled', true);
      $("#txtCompanyLink").prop('disabled', true);
      $("#txtCompanyIndustry").prop('disabled', true);
      $("#txtCompanyCustomerType").prop('disabled', true);
      $("#txtCompanyType").prop('disabled', true);
      $("#txtCompanyDescription").prop('disabled', true);
      //$("#ddlCompanyGroup").prop('disabled', true);


      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitcompany").show();

      $("#txtCompanyCode").removeAttr('disabled');
      $("#txtCompanyName").removeAttr('disabled');
      $("#txtCompanyContactName").removeAttr('disabled');
      $("#txtCompanyLink").removeAttr('disabled');
      $("#txtCompanyIndustry").removeAttr('disabled');
      $("#txtCompanyCustomerType").removeAttr('disabled');
      $("#txtCompanyType").removeAttr('disabled');
      $("#txtCompanyDescription").removeAttr('disabled');
      //$("#ddlCompanyGroup").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalCompany').modal('hide');
    }

  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitcompany").hide();
      $("#txtCompanyCode").prop('disabled', true);
      $("#txtCompanyName").prop('disabled', true);
      $("#txtCompanyContactName").prop('disabled', true);
      $("#txtCompanyLink").prop('disabled', true);
      $("#txtCompanyIndustry").prop('disabled', true);
      $("#txtCompanyCustomerType").prop('disabled', true);
      $("#txtCompanyType").prop('disabled', true);
      $("#txtCompanyDescription").prop('disabled', true);
      $("#ddlCompanyGroup").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitcompany").show();
      $("#txtCompanyCode").removeAttr('disabled');
      $("#txtCompanyName").removeAttr('disabled');
      $("#txtCompanyContactName").removeAttr('disabled');
      $("#txtCompanyLink").removeAttr('disabled');
      $("#txtCompanyIndustry").removeAttr('disabled');
      $("#txtCompanyCustomerType").removeAttr('disabled');
      $("#txtCompanyType").removeAttr('disabled');
      $("#txtCompanyDescription").removeAttr('disabled');
      $("#ddlCompanyGroup").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalCompany').modal('hide');
    }

  }

  //For Pagination
  LoadCompanyUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  OnLoadCompanyList(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadCompanyUpdatePagination(traget);
      this.LoadCompany();
    }
  }

  async OnLoadCountCompanyList(auth_token, viewfromcompgroup: string | null = null) {
    //call function load count all ticket list on hand current role user
    //var auth_token = await this.TokenService.RefreshToken();
    auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadCountCompanyList(auth_token, viewfromcompgroup).then(data => {
        this.CompanyTotal = data;
        if (this.CompanyTotal == 0) this.currentPageNumber = 0;
        this.totalPages = Math.ceil(this.CompanyTotal / environment.PageSize);

      });
    }
  }

  async LoadCompanyGroupList(bySearch: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      //console.log('currentPageNumberCompanyGroup', this.currentPageNumberCompanyGroup);
      //console.log('environment.PageSizeSmall', environment.PageSizeSmall);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumberCompanyGroup = 1;
      }

      const objectjson = {
        CompanyGroupCode: this.checkUndefinedString(this.txtSearchGroupCode),
        CompanyGroupName: this.checkUndefinedString(this.txtSearchGroupName),
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumberCompanyGroup - 1) < 0 ? 0 : (this.currentPageNumberCompanyGroup - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Company/GetCompanyGroup",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.CompanyGroupList = response;
      this.totalItems = this.CompanyGroupList.length;

      if (this.CompanyGroupList.length <= 0) {
        this.currentPageNumberCompanyGroup = 0;
      } else {
        if (this.currentPageNumberCompanyGroup == 0) this.currentPageNumberCompanyGroup = 1;
        this.totalItems = Number(this.CompanyGroupList[0].itemTotal);
      }

      this.totalPagesCompanyGroup = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadCompanyGroupList(target = null) {

    //console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumberCompanyGroup = target.currentPageNumber;
      this.totalPagesCompanyGroup = target.totalPages;
    }

    this.LoadCompanyGroupList();
  }

  chkallCompanyGroupclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxcompanyGroup"]').prop('checked', check);

  }

  async btnClick_viewCompanyinGroup(CompanyGroupCode: string, CompanyGroupName: string, CompanyGroupTypeCode: string) {
    this.companyGroupCodeSend = CompanyGroupCode;
    this.companyGroupTypeCodeSend = CompanyGroupTypeCode;

    //console.log('companyGroupTypeCodeSend', this.companyGroupTypeCodeSend);
    //console.log('companyGroupCodeSend', this.companyGroupCodeSend);

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadLookup('COMPANYINDUSTRY', auth_token).then((data) => {
        this.IndustryList = data;
      })
      this.loadLookup('COMPANYCUSTOMERTPYE', auth_token).then((data) => {
        //this.CustomerTypeList = data;
        this.CustomerTypeList = data; // เก็บ list เต็มไว้เผื่อใช้ซ้ำ
        this.applyCustomerTypeFilter(this.companyGroupTypeCodeSend, data);

        //console.log('CustomerTypeList!!', this.CustomerTypeList);
      })

      if (this.companyGroupTypeCodeSend === '1') {
        this.isShowCompanyCode = false;
        this.form.get('txtCompanyCode')?.setValue('');
        this.form.get('txtCompanyCode')?.clearValidators();
        this.form.get('txtCompanyCode')?.disable(); // เพิ่มบรรทัดนี้
        this.form.get('txtCompanyCode')?.updateValueAndValidity();
        
      }
      else {
        this.isShowCompanyCode = true;
        this.form.get('txtCompanyCode')?.enable(); // เพิ่มบรรทัดนี้
        this.form.get('txtCompanyCode')?.setValidators([Validators.required]);
        this.form.get('txtCompanyCode')?.updateValueAndValidity();
      }

      const viewfromcompgroup = "G";
      this.viewfromcompgroupclick = "G";

      //this.LoadCompany(viewfromcompgroup);
      //this.LoadCountCompanyList(auth_token, viewfromcompgroup);
      //this.OnLoadCountCompanyList(auth_token, viewfromcompgroup);
      this.currentPageNumber = 1;
      this.txtSearchCompanyName = "";
      this.ddlSearchCustomerType = null;
      this.LoadCompanyListV2(this.viewfromcompgroupclick);

    }
    this.isVisible = true; // Show company section
    this.GroupNameSelected = CompanyGroupName;
  }

  btnClick_onCreateCompanyGroup() {
    this.isOnUpdateCompGroup = false;

    this.formCompanyGroup.reset();
    this.txtCompanyGroupName = "";
    this.txtCompanyGroupDesc = "";

    if (this.CompanyGroupTypeList && this.CompanyGroupTypeList.length > 0) {
    setTimeout(() => {
      this.CompanyGroupTypeCode = this.CompanyGroupTypeList[0].LookupCode;
      this.formCompanyGroup.patchValue({
        CompanyGroupTypeCode: this.CompanyGroupTypeList[0].LookupCode
      });
      this.cdRef.detectChanges();
    }, 100);
  }

    this.isShowDisableGroupType = false;
    
    this.CompanyGroupTypeList = [];
    this.CompanyGroupTypeList = this.CompanyGroupTypeListInit.filter(x => x.LookupCode !== "2");
    this.isShowDisableGroupTypeCustomer = true;

    console.log('CompanyGroupTypeList', this.CompanyGroupTypeList);

    $('#ModalCompanyGroup').modal('show');
  }

  async btnClick_submitInsertCompanyGroup() {
  if (this.formCompanyGroup.valid) {
  } else {
    this.markFormGroupTouched(this.formCompanyGroup); // Force touched all field show error
  }

    //console.log('CompanyGroupTypeCode', this.CompanyGroupTypeCode)
    //console.log('txtCompanyGroupDesc', this.checkUndefinedString(this.txtCompanyGroupDesc))

    const codeSelected = this.formCompanyGroup.get('CompanyGroupTypeCode')?.value;
    const groupCode = this.formCompanyGroup.get('txtCompanyGroupCode')?.value;

    if(codeSelected === "3" && groupCode && groupCode.trim() !== ''){
      //console.log('Checking duplicate for code:', groupCode);

      this.DupCompanyGroupCodeList = await this.checkDuplicateCompanyGroupCode(groupCode);

      // Call Validate Duplicate Company Group Code
      this.formCompanyGroup.get('txtCompanyGroupCode')?.updateValueAndValidity();

      if (this.DupCompanyGroupCodeList.length > 0) {
        this.markFormGroupTouched(this.formCompanyGroup);
          //console.log('Duplicate found, cannot submit');
        return;
      }
    }

    if (this.formCompanyGroup.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        //this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };        

        var objectjson = {};
        objectjson['CompanyGroupTypeCode'] = this.checkUndefinedString(this.CompanyGroupTypeCode);
        objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.txtCompanyGroupCode).trim();
        objectjson['CompanyGroupName'] = this.checkUndefinedString(this.txtCompanyGroupName);
        objectjson['CompanyGroupDesc'] = this.checkUndefinedString(this.txtCompanyGroupDesc);
        objectjson['CompanyGroupCreateBy'] = this.checkUndefinedString(this._EmpCode);

        let strjson = JSON.stringify(objectjson);

        try {
        await this.httpClient.post<CompanyGroupInfo[]>(
          this.baseurl + "Company/InsertComnapyGroup",
          strjson,
          httpOptions
        ).toPromise();

        console.log("Insert success, reloading lists...");
        this.txtSearchGroupCode = '';
        this.txtSearchGroupName = '';

        $('#ModalCompanyGroup').modal('hide');
        $('#ModalCreateCompGroupComplete').modal();

        setTimeout(async () => {
          await this.LoadCompanyGroupList("Y");
          await this.LoadCompanyGroupListNoPaging();
        }, 900);

        console.log("All operations completed.");

      } catch (error) {
        console.error("An error occurred:", error);
      }

      }

    } else {
      this.validateAllFormFields(this.formCompanyGroup);
    }
  }

  isFieldCompGroupValid(field: string) {
    return !this.formCompanyGroup.get(field).valid && this.formCompanyGroup.get(field).touched;
  }

  displayCompGroupFieldCss(field: string) {
    return {
      'has-error': this.isFieldCompGroupValid(field),
      'has-feedback': this.isFieldCompGroupValid(field)
    };
  }

  isFieldContactValid(field: string) {
    return !this.formCompanyContact.get(field).valid && this.formCompanyContact.get(field).touched;
  }

  btnClick_onUpdateCompanyGroup(id) {
    $('#ModalCompanyGroup').modal('hide');
    this.isOnUpdateCompGroup = true

    console.log("btnClick_onUpdateCompanyGroup id = " + id);

    let index = this.CompanyGroupList.findIndex(x => x.CompanyGroupID == id);

    this.txtCompanyGroupCode = this.CompanyGroupList[index].CompanyGroupCode != null ? this.CompanyGroupList[index].CompanyGroupCode : null
    this.txtCompanyGroupName = this.CompanyGroupList[index].CompanyGroupName != null ? this.CompanyGroupList[index].CompanyGroupName : null
    this.txtCompanyGroupDesc = this.CompanyGroupList[index].CompanyGroupDesc != null ? this.CompanyGroupList[index].CompanyGroupDesc : null
    this.CompanyGroupTypeCode = this.CompanyGroupList[index].CompanyGroupTypeCode != null ? this.CompanyGroupList[index].CompanyGroupTypeCode : null

    this.formCompanyGroup.patchValue({
      txtCompanyGroupCode: this.CompanyGroupList[index].CompanyGroupCode != null ? this.CompanyGroupList[index].CompanyGroupCode : null,
      txtCompanyGroupName: this.CompanyGroupList[index].CompanyGroupName != null ? this.CompanyGroupList[index].CompanyGroupName : null,
      txtCompanyGroupDesc: this.CompanyGroupList[index].CompanyGroupDesc != null ? this.CompanyGroupList[index].CompanyGroupDesc : null,
      CompanyGroupTypeCode: this.CompanyGroupList[index].CompanyGroupTypeCode != null ? this.CompanyGroupList[index].CompanyGroupTypeCode : null
    });

    this.hidCompanyGroupID = this.CompanyGroupList[index].CompanyGroupID    
    
    // Part rebind radio CompanyGroupTypeCode
    if (this.CompanyGroupTypeCode == "3"){
      //this.CompanyGroupTypeList = this.CompanyGroupTypeList.filter(x => x.LookupCode !== "1");
      this.isShowDisableGroupType = false;
      this.isShowDisableGroupTypeCustomer = true;
    } else {
      this.isShowDisableGroupType = false;
      this.isShowDisableGroupTypeCustomer = true;
      this.CompanyGroupTypeList = [];
      this.CompanyGroupTypeList = this.CompanyGroupTypeListInit.filter(x => x.LookupCode !== "2");
    }

    //console.log('CompanyGroupTypeCode at onUpdate!!', this.CompanyGroupTypeCode);

    $('#ModalCompanyGroup').modal();

  }

  async btnClick_submitUpdateCompanyGroup(id) {
    const codeSelected = this.formCompanyGroup.get('CompanyGroupTypeCode')?.value;
    const groupCode = this.formCompanyGroup.get('txtCompanyGroupCode')?.value;

    const result = this.validateService.isValidLeadFormat(groupCode);
    //console.log('Check current companyGroupTypeCodeSend:', this.CompanyGroupTypeCode);

    if (this.CompanyGroupTypeCode === "3") {
      if (!result) {
        this.formCompanyGroup.get('txtCompanyGroupCode')?.setErrors({ companyGroupCodeFormatInvalid: true });
        this.formCompanyGroup.get('txtCompanyGroupCode')?.markAsTouched(); // ให้ขึ้น error ทันที
        return;
      }
    }

    if(codeSelected === "3" && groupCode && groupCode.trim() !== ''){
      //console.log('Checking duplicate for code:', groupCode);

      this.DupCompanyGroupCodeList = [];
      const allDuplicates = await this.checkDuplicateCompanyGroupCode(groupCode);
  
      this.DupCompanyGroupCodeList = allDuplicates.filter(item => 
        item.CompanyGroupID !== this.hidCompanyGroupID
      );

      this.formCompanyGroup.get('txtCompanyGroupCode')?.updateValueAndValidity();

      if (this.DupCompanyGroupCodeList.length > 0) {
        this.markFormGroupTouched(this.formCompanyGroup);
          //console.log('Duplicate found, cannot submit');
            return;
          }
        }

      if (this.formCompanyGroup.valid) {
        var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //this.OnUpdating('y');

        id = this.hidCompanyGroupID

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`

          })
        };

        var objectjson = {};
        objectjson['CompanyGroupID'] = id;
        objectjson['CompanyGroupTypeCode'] = this.checkUndefinedString(this.CompanyGroupTypeCode);
        objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.txtCompanyGroupCode).trim();
        objectjson['CompanyGroupName'] = this.checkUndefinedString(this.txtCompanyGroupName);
        objectjson['CompanyGroupDesc'] = this.checkUndefinedString(this.txtCompanyGroupDesc);
        objectjson['CompanyGroupUpdateBy'] = this.checkUndefinedString(this._EmpCode);

        let strjson = JSON.stringify(objectjson);

        try {
        await this.httpClient.post<CompanyGroupInfo[]>(
          this.baseurl + "Company/UpdateComnapyGroup",
          strjson,
          httpOptions
        ).toPromise();

        console.log("Update success");
        $('#ModalCompanyGroup').modal('hide');
        $('#ModalUpdateCompGroupComplete').modal();

        setTimeout(async () => {
        await this.LoadCompanyGroupList();
        await this.LoadCompanyGroupListNoPaging(); 
        console.log("All operations completed.");
        }, 900);

      } catch (error) {
        console.error("Update fail", error);
      }
      }
    } else {
      this.validateAllFormFields(this.formCompanyGroup);
    }
  }


  async btnClick_onDeleteCompanyGroupList() {
    if (confirm("Are you sure to delete this Company Group?")) {

      var checkkedcompanygroup = $('[name="checkboxcompanyGroup"]:checked');
      let num = checkkedcompanygroup.length;
      let listCompanyGroupModel = [];
      

      for (var i = 0; i < num; i++) {
        var CompanyGroupcurrent = <HTMLInputElement>checkkedcompanygroup[i];
        let companygroupInfo = new CompanyGroupInfo;
        companygroupInfo.CompanyGroupID = parseInt(CompanyGroupcurrent.value);

          var currentCompanyGroup = this.CompanyGroupList.filter(x => { return x.CompanyGroupID == companygroupInfo.CompanyGroupID });
          var isOwner = (currentCompanyGroup[0].CompanyGroupCreateBy == this._EmpCode);

          console.log(" Delete id = " + companygroupInfo.CompanyGroupID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
          if (isOwner || (this._RoleCode == "ADMIN")) {
            listCompanyGroupModel.push(companygroupInfo);
          } else
          {
            //this.titlemodal = ""
            //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
            this.detailmodal = "You don't have permission to delete this company. Please contact" + currentCompanyGroup[0].CompanyGroupCreateBy;
            $('#ModalError .modal-header').text("Information");
            $('#ModalError .modal-header').addClass('bg-blue');
            $('#ModalError').modal();

            listCompanyGroupModel = [];
            break; //break loop
          }
      }

      if (listCompanyGroupModel.length > 0) {
        this.deleteListCompanyGroup(listCompanyGroupModel)
      }

    }
  }

  async deleteListCompanyGroup(listCompanyGroupModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
     

      let strjsonCompGroupInfo = JSON.stringify(listCompanyGroupModel);

      this.httpClient.post<CompanyGroupInfo[]>(this.baseurl + "Company/DeleteListCompanyGroup", strjsonCompGroupInfo, httpOptions)
        .toPromise()
        .then(data => {
          console.log("delete company group list successfully");
          $('#ModalDeleteCompGroupComplete').modal('show');
          this.onModalClose();
          this.LoadCompanyGroupList();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  async LoadCompanyGroupListNoPaging() {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Company/GetCompanyGroup",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.CompanyGroupLisNoPaging = response;

    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  async LoadCompanyListV2(viewfromcompgroup: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      //console.log('currentPageNumber', this.currentPageNumber);
      //console.log('environment.PageSize', environment.PageSize);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      //const objectjson = {
        //rowFetch: environment.PageSize,
        //rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * environment.PageSize
      //};

      var objectjson = {};

      if (viewfromcompgroup === "Y") {
        this.currentPageNumber = 1; // Reset to page 1 when viewing from company group
      } else {
        objectjson['CompanyCustomerType'] = this.ddlSearchCustomerType;
        objectjson['CompanyName'] = this.checkUndefinedString(this.txtSearchCompanyName);
      }


      if (this.viewfromcompgroupclick === "G") {
        //this.currentPageNumber = 1; // Reset to page 1 when viewing from company group
        objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.companyGroupCodeSend);
      } 

        //objectjson['CompanyGroupCode'] = this.checkUndefinedString(this.companyGroupCodeSend);

        objectjson['CompanyFlagDelete'] = "N";
        objectjson['rowFetch'] = environment.PageSize;
        objectjson['rowOFFSet'] = ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * environment.PageSize;

      const response = await this.httpClient.post<any>(
        this.baseurl + "Company/GetCompanyVer02",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.CompanyList = response;
      this.totalItems = this.CompanyList.length;

      if (this.CompanyList.length <= 0) {
        this.currentPageNumber = 0;
      } else {
        if (this.currentPageNumber == 0) this.currentPageNumber = 1;
        this.totalItems = Number(this.CompanyList[0].itemTotal);
      }

      this.totalPages = Math.ceil(this.totalItems / environment.PageSize);

      //console.log('PageSize:', environment.PageSize);
      //console.log('Total Items:', this.totalItems);
      //console.log('Total Pages:', this.totalPages);
      
    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadCompanyListV2(target = null) {

  //console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumber = target.currentPageNumber;
      this.totalPages = target.totalPages;
    }

    //console.log('OnLoadCompanyListV2 currentPageNumber:', this.currentPageNumber);
    //console.log('OnLoadCompanyListV2 totalPages:', this.totalPages);

    this.LoadCompanyListV2();
  }

  btnClick_onAddCompanyContact(code) {
    this.hidCompanyContactCode = code;
    this.CompanyContactList = [];
    $('#ModalCompanyContact').modal('hide');
    this.isOnUpdate = true
    this.LoadCompanyContactList(this.hidCompanyContactCode);

  }

  btnClick_onCreateCompanyContact() {
    this.isOnUpdateContact = false;
    this.formCompanyContact.reset();

    $('#ModalCompanyContactAddEdit').modal('show');
  }

  async LoadCompanyContactList(companycode: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }
      //console.log('companycode', companycode);
      //console.log('currentPageNumberCompanyContact', this.currentPageNumberCompanyContact);
      //console.log('environment.PageSizeSmall', environment.PageSizeSmall);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        CompanyCode: companycode,
        rowFetch: environment.PageSizeSmall,
        rowOFFSet: ((this.currentPageNumberCompanyContact - 1) < 0 ? 0 : (this.currentPageNumberCompanyContact - 1)) * environment.PageSizeSmall
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Company/GetCompanyContact",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.CompanyContactList = response;
      this.totalItems = this.CompanyContactList.length;

      if (this.CompanyContactList.length <= 0) {
        this.currentPageNumberCompanyContact = 0;
      } else {
        if (this.currentPageNumberCompanyContact == 0) this.currentPageNumberCompanyContact = 1;
        this.totalItems = Number(this.CompanyContactList[0].itemTotal);
      }

      this.totalPagesCompanyContact = Math.ceil(this.totalItems / environment.PageSizeSmall);
    } catch (error) {
      console.error('Error loading company contact:', error);
      alert('An error occurred while loading company contact data. Please try again.');
    } finally {
      this.loading = false;
      $('#ModalCompanyContact').modal();
    }
  }

  OnLoadCompanyContactList(target = null) {

  //console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumberCompanyContact = target.currentPageNumber;
      this.totalPagesCompanyContact = target.totalPages;
    }

    //console.log('OnLoadCompanyListV2 currentPageNumber:', this.currentPageNumber);
    //console.log('OnLoadCompanyListV2 totalPages:', this.totalPages);

    this.LoadCompanyContactList(this.hidCompanyContactCode);
  }

  async btnClick_submitInsertCompanyContact() {
    if (this.formCompanyContact.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        //this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['CompanyCode'] = this.checkUndefinedString(this.hidCompanyContactCode);
        objectjson['CompanyContactName'] = this.checkUndefinedString(this.formCompanyContact.get('txtCompanyContactName')?.value);
        objectjson['CompanyContactTel'] = this.checkUndefinedString(this.formCompanyContact.get('txtCompanyContactTel')?.value);
        objectjson['CompanyContactEmail'] = this.checkUndefinedString(this.formCompanyContact.get('txtCompanyContactEmail')?.value);
        objectjson['CompanyContactFax'] = this.checkUndefinedString(this.formCompanyContact.get('txtCompanyContactFax')?.value);
        objectjson['CompanyContactCreateBy'] = this.checkUndefinedString(this._EmpCode);

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<CompanyContactInfo[]>(this.baseurl + "Company/InsertComnapyContact", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            //this.OnCreating('n');            
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              $('#ModalCompanyContactAddEdit').modal('hide');
              $('#ModalCreateCompContactComplete').modal();
              this.LoadCompanyContactList(this.hidCompanyContactCode);

            }
          )

      }

    } else {
      this.validateAllFormFields(this.formCompanyContact);
    }
  }

  btnClick_onUpdateCompanyContact(id) {
    //$('#txtCompanyCode').attr('disabled', 'disabled');
    $('#ModalCompanyContactAddEdit').modal('hide');
    this.isOnUpdateContact = true

    const contact = this.CompanyContactList.find(x => x.CompanyContactID == id);

    this.hidCompanyContactID = contact.CompanyContactID;

    this.formCompanyContact.patchValue({
      txtCompanyContactName: contact.CompanyContactName || null,
      txtCompanyContactTel: contact.CompanyContactTel || null,
      txtCompanyContactEmail: contact.CompanyContactEmail || null,
      txtCompanyContactFax: contact.CompanyContactFax || null,
    });

    $('#ModalCompanyContactAddEdit').modal();
  }

  async btnClick_submitUpdateCompanyContact(id) {
    if (this.formCompanyContact.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //this.OnUpdating('y');

        id = this.hidCompanyContactID
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`

          })
        };

        const formValue = this.formCompanyContact.value;

        var objectjson = {};
        objectjson['CompanyContactID'] = id;
        objectjson['CompanyContactName'] = this.checkUndefinedString(formValue.txtCompanyContactName);
        objectjson['CompanyContactTel'] = this.checkUndefinedString(formValue.txtCompanyContactTel);
        objectjson['CompanyContactEmail'] = this.checkUndefinedString(formValue.txtCompanyContactEmail);
        objectjson['CompanyContactFax'] = this.checkUndefinedString(formValue.txtCompanyContactFax);
        objectjson['CompanyContactUpdateBy'] = this.checkUndefinedString(this._EmpCode);

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<CompanyGroupInfo[]>(this.baseurl + "Company/UpdateComnapyContact", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            //this.OnUpdating('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              //this.OnUpdating('n');
              $('#ModalCompanyContactAddEdit').modal('hide');
              $('#ModalCreateCompContactComplete').modal();
              this.LoadCompanyContactList(this.hidCompanyContactCode);
            }
          )
      }
    } else {
      this.validateAllFormFields(this.formCompanyContact);
    }
  }

  chkallCompanyContactclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxcompanyContact"]').prop('checked', check);

  }

  async btnClick_onDeleteCompanyContactList() {
    if (confirm("Are you sure to delete this Company Contact?")) {

      var checkkedcompanyconact = $('[name="checkboxcompanyContact"]:checked');
      let num = checkkedcompanyconact.length;
      let listCompanyContactModel = [];
      

      for (var i = 0; i < num; i++) {
        var CompanyContactcurrent = <HTMLInputElement>checkkedcompanyconact[i];
        let companycontactInfo = new CompanyContactInfo;
        companycontactInfo.CompanyContactID = parseInt(CompanyContactcurrent.value);

          var currentCompanyContact = this.CompanyContactList.filter(x => { return x.CompanyContactID == companycontactInfo.CompanyContactID });
          var isOwner = (currentCompanyContact[0].CompanyContactCreateBy == this._EmpCode);

          console.log(" Delete id = " + companycontactInfo.CompanyContactID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
          if (isOwner || (this._RoleCode !== null && this._RoleCode !== "")) {
            listCompanyContactModel.push(companycontactInfo);
          } else
          {
            //this.titlemodal = ""
            //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
            this.detailmodal = "You don't have permission to delete this company. Please contact" + currentCompanyContact[0].CompanyContactCreateBy;
            $('#ModalError .modal-header').text("Information");
            $('#ModalError .modal-header').addClass('bg-blue');
            $('#ModalError').modal();

            listCompanyContactModel = [];
            break; //break loop
          }
      }

      if (listCompanyContactModel.length > 0) {
        this.deleteListCompanyContact(listCompanyContactModel)
      }

    }
  }

  async deleteListCompanyContact(listCompanyContactModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
     

      let strjsonCompContactInfo = JSON.stringify(listCompanyContactModel);

      this.httpClient.post<CompanyContactInfo[]>(this.baseurl + "Company/DeleteListCompanyContact", strjsonCompContactInfo, httpOptions)
        .toPromise()
        .then(data => {
          console.log("delete company contact list successfully");
          $('#ModalDeleteCompContactComplete').modal('show');
          this.onModalClose();
          this.LoadCompanyContactList(this.hidCompanyContactCode);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  onModalClose() {
    if (this.chkAllContact) {
      this.chkAllContact.nativeElement.checked = false;
    }
    if (this.chkAllComGroup) {
      this.chkAllComGroup.nativeElement.checked = false;
    }
    if (this.chkAllAddress) {
      this.chkAllAddress.nativeElement.checked = false;
    }
  }

  ngAfterViewInit(): void {
    $('#ModalCompanyContact').on('hidden.bs.modal', () => {
      this.onModalClose();
    });
  }

  btnClick_SearchCompanyGroupList() {
    this.LoadCompanyGroupList("Y");
  }

  ClearCompanySearch() {
   this.txtSearchGroupCode = ""; 
   this.txtSearchGroupName = "";
   this.LoadCompanyGroupList("Y");
  }

  onCompanyGroupTypeChange(code: string) {
    //console.log('CompanyGroupTypeCode changed to:', code);
  }

  private companyGroupCodeValidator(): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    const codeSelected = this.formCompanyGroup?.get('CompanyGroupTypeCode')?.value;
    const groupCode = control.value;
    
    //console.log('CompanyGroupTypeCode:', codeSelected);
    //console.log('groupCode:', groupCode);
    //console.log('CompanyGroupTypeList length:', this.CompanyGroupTypeList?.length);
    
    // Condition: Pick TypeCode = '1' และ groupCode ''
    if (codeSelected === '3' && (!groupCode || groupCode.trim() === '')) {
      return { companyGroupCodeRequired: true };
    }
    
    // Check List length when CompanyGroupTypeList have data & txtCompanyGroupCode != null
    if (codeSelected === '3' && groupCode && groupCode.trim() !== '' && this.DupCompanyGroupCodeList?.length > 0) {
      return { companyGroupCodeInvalid: true };
    }
    
    return null; 
  };
}

  private markFormGroupTouched(formGroup: FormGroup) {
  Object.values(formGroup.controls).forEach(control => {
    control.markAsTouched();
    control.updateValueAndValidity();
  });
}

  async checkDuplicateCompanyGroupCode(groupCode: string): Promise<any[]> {
  try {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      
      const result = await this.httpClient.post<any[]>(
        this.baseurl + "Company/GetCompanyGroup", 
        JSON.stringify({ CompanyGroupCode: groupCode }), 
        httpOptions
      ).toPromise();
      
      return result || [];
    }
    return [];
  } catch (error) {
    console.error('Error checking duplicate:', error);
    return [];
  }
}

  onSearchCompanyGroupTextChange(value: string) {
    this.searchCompanyGroupText = value;
    this.filteredCompanyGroupList = this.CompanyGroupLisNoPaging.filter(x =>
      (x.CompanyGroupCode + ' - ' + x.CompanyGroupName).toLowerCase().includes(value.toLowerCase())
    );
  }


  onCompanyGroupInputFocus() {
    this.showCompanyGroupDropdown = true;
    this.onSearchCompanyGroupTextChange(this.searchCompanyGroupText || '');
  }

  onCompanyGroupInputBlur() {
    setTimeout(() => this.showCompanyGroupDropdown = false, 200);
  }

  selectCompanyGroup(item: any) {
    this.searchCompanyGroupText = `${item.CompanyGroupCode} - ${item.CompanyGroupName}`;
    this.ddlCompanyGroup = item.CompanyGroupCode;  // กำหนดค่าเหมือน select
  }

  applyCustomerTypeFilter(groupTypeCode: string, fullList: any[]) {
  this.CustomerTypeFullList = fullList; 
  if (groupTypeCode === "1") {
    // กรณีเป็น Lead
    this.CustomerTypeList = fullList.filter(x => x.LookupCode === "1");
  } else {
    // กรณี Prospect หรือ Customer
    this.CustomerTypeList = fullList.filter(x =>
      x.LookupCode === "2" || x.LookupCode === "3"
    );

    // this.txtCompanyCustomerType = null;
    // this.form.patchValue({ txtCompanyCustomerType: null });
    // this.form.get('txtCompanyCustomerType')?.enable();
  }
}

  async LoadCompanyListNoPaging() {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Company/GetCompany",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.CompanyCheckDupList = response;
      //console.log('CompanyCheckDupList!!', this.CompanyCheckDupList);

    } catch (error) {
      console.error('Error loading company no paging:', error);
      alert('An error occurred while loading company no paging data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  async btnClick_onAddCompanyAddress(id) {
    this.hidCompanyIDForAddress = id;
    this.CompanyAddressList = [];
    this.isCompAddressOnUpdate = true
    //await this.LoadProvinceList();
    await this.LoadCompanyAddressList(this.hidCompanyIDForAddress);
    

    $('#ModalCompanyAddress').modal('hide');
  }

  async LoadCompanyAddressList(companyid: number | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }
      //console.log('companyid', companyid);
      //console.log('currentPageNumberCompanyAddress', this.currentPageNumberCompanyAddress);
      //console.log('environment.PageSizeSmall', environment.PageSizeSmall);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        CompanyID: companyid,
        rowFetch: environment.PageSizeSmall,
        rowOFFSet: ((this.currentPageNumberCompanyAddress - 1) < 0 ? 0 : (this.currentPageNumberCompanyAddress - 1)) * environment.PageSizeSmall
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Company/GetCompanyAddress",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.CompanyAddressList = response;
      this.totalItems = this.CompanyAddressList.length;

      if (this.CompanyAddressList.length <= 0) {
        this.currentPageNumberCompanyAddress = 0;
      } else {
        if (this.currentPageNumberCompanyAddress == 0) this.currentPageNumberCompanyAddress = 1;
        this.totalItems = Number(this.CompanyAddressList[0].itemTotal);
      }

      this.totalPagesCompanyAddress = Math.ceil(this.totalItems / environment.PageSizeSmall);
    } catch (error) {
      console.error('Error loading company address:', error);
      alert('An error occurred while loading company address data. Please try again.');
    } finally {
      this.loading = false;
      $('#ModalCompanyAddress').modal();
    }
  }

  OnLoadCompanyAddressList(target = null) {
    if (target != null) {
      this.currentPageNumberCompanyAddress = target.currentPageNumber;
      this.totalPagesCompanyAddress = target.totalPages;
    }

    this.LoadCompanyAddressList(this.hidCompanyIDForAddress);
  }

  async LoadProvinceList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }
      //console.log('companyid', companyid);
      //console.log('currentPageNumberCompanyAddress', this.currentPageNumberCompanyAddress);
      //console.log('environment.PageSizeSmall', environment.PageSizeSmall);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {};

      const response = await this.httpClient.post<any>(
        this.baseurl + "Province/GetProvince",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ProvinceList = response;
    } catch (error) {
      console.error('Error loading province:', error);
      alert('An error occurred while loading province data. Please try again.');
    } finally {
    }
  }

  btnClick_onCreateCompanyAddress() {
    this.isCompAddressOnUpdate = false;
    this.formCompanyAddress.reset(); // formCompanyContact

    if(this.CountryList.length > 0){
        const firstCountryCode = this.CountryList[0].CountryCode;
        this.formCompanyAddress.patchValue({CompanyCountryCode: firstCountryCode});
      }

    $('#ModalCompanyAddressAddEdit').modal('show'); // ModalCompanyContactAddEdit
  }

  isFieldAddressValid(field: string) {
    return !this.formCompanyAddress.get(field).valid && this.formCompanyAddress.get(field).touched;
  }

  async LoadDistrictList(provincecode: string) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }
      //console.log('provincecode', provincecode);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        province_code: provincecode
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "District/GetDistrict",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.DistrictList = response;
    } catch (error) {
      console.error('Error loading district:', error);
      alert('An error occurred while loading district data. Please try again.');
    } finally {
    }
  }

  async LoadSubDistrictList(districtcode: string) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }
      //console.log('districtcode', districtcode);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        district_code: districtcode
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "SubDistrict/GetSubDistrict",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.SubDistrictList = response;

      if (this.SubDistrictList.length > 0) {
        const firstSubDistrictPostCode = this.SubDistrictList[0].postCode;

        this.formCompanyAddress.patchValue({CompanyPostCode: firstSubDistrictPostCode});
      }

    } catch (error) {
      console.error('Error loading subdistrict:', error);
      alert('An error occurred while loading subdistrict data. Please try again.');
    } finally {
    }
  }

  async btnClick_submitInsertCompanyAddress() {
    //console.log('getdata!!', this.checkUndefinedString(this.formCompanyAddress.get('CompanyAddress')?.value)); 
    this.markFormGroupTouched(this.formCompanyAddress);

    if (this.formCompanyAddress.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        //this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['CompanyID'] = this.hidCompanyIDForAddress;
        objectjson['CompanyAddress'] = this.checkUndefinedString(this.formCompanyAddress.get('CompanyAddress')?.value);
        objectjson['CompanyProvinceCode'] = this.checkUndefinedString(this.formCompanyAddress.get('CompanyProvinceCode')?.value);
        objectjson['CompanyDistrictCode'] = this.checkUndefinedString(this.formCompanyAddress.get('CompanyDistrictCode')?.value);
        objectjson['CompanySubDistrictCode'] = this.checkUndefinedString(this.formCompanyAddress.get('CompanySubDistrictCode')?.value);
        objectjson['CompanyPostCode'] = this.checkUndefinedString(this.formCompanyAddress.get('CompanyPostCode')?.value);
        objectjson['CompanyAddressCountryCode'] = this.checkUndefinedString(this.formCompanyAddress.get('CompanyCountryCode')?.value);
        objectjson['CompanyAddressCreateBy'] = this.checkUndefinedString(this._EmpCode);

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<CompanyAddressInfo[]>(this.baseurl + "Company/InsertComnapyAddress", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            //this.OnCreating('n');            
          },
            async () => {
              console.log("Insert = " + this.isSubmitted)
              //await this.LoadCompanyAddressList(this.hidCompanyIDForAddress);
              $('#ModalCompanyAddressAddEdit').modal('hide');
              $('#ModalCompanyAddressAddEditComplete').modal();
              await this.LoadCompanyAddressList(this.hidCompanyIDForAddress);
            }
          )

      }

    } else {
      this.validateAllFormFields(this.formCompanyAddress);
    }
  }

  async btnClick_onUpdateCompanyAddress(id: any) { // ใช้ any หรือระบุ type ของ id
    $('#ModalCompanyAddressAddEdit').modal('hide');
    this.isCompAddressOnUpdate = true;

    const address = this.CompanyAddressList.find(x => x.CompanyAddressID == id);

    if (!address) {
      console.warn('Address not found for ID:', id);
      return;
    }

    this.hidCompanyAddressID = address.CompanyAddressID;
    // 1. ตั้งค่าจังหวัดก่อน
    //    (จะ trigger valueChanges ของ CompanyProvinceCode -> LoadDistrictList)
    this.formCompanyAddress.patchValue({
      CompanyProvinceCode: address.CompanyProvinceCode || null,
      CompanyAddress: address.CompanyAddress,
      CompanyCountryCode: address.CompanyAddressCountryCode || null
    });

    // เนื่องจาก LoadDistrictList ถูกเรียกแบบ await ใน valueChanges ของ CompanyProvinceCode
    // คุณไม่จำเป็นต้อง await ตรงนี้อีกครั้ง
    // แต่ต้องมั่นใจว่า CompanyDistrictCode มีการ subscribe valueChanges เพื่อเรียก LoadSubDistrictList เช่นกัน

    // 2. ตั้งค่าอำเภอ
    //    (จะ trigger valueChanges ของ CompanyDistrictCode -> LoadSubDistrictList)
    //    อาจต้องมี setTimeout เล็กน้อย หาก CompanyDistrictCode dropdown ยังไม่ render option ของจังหวัดเสร็จ
    //    แต่ปกติ valueChanges ของ CompanyProvinceCode จะรับประกันว่า LoadDistrictList เสร็จก่อน
    //    ดังนั้น DistrictList ควรจะพร้อมแล้ว
    setTimeout(() => {
      this.formCompanyAddress.patchValue({
        CompanyDistrictCode: address.CompanyDistrictCode || null,
      });
    }, 0); // ใช้ setTimeout 0ms เพื่อให้รันใน Event Loop รอบถัดไป

    // 3. ตั้งค่าตำบล
    //    (จะไม่ trigger load เพิ่มเติมถ้า LoadSubDistrictList จัดการ PostCode แล้ว)
    //    และรหัสไปรษณีย์
    //    ใช้ setTimeout อีกครั้งเพื่อให้แน่ใจว่า SubDistrictList พร้อมแล้ว
    setTimeout(() => {
      this.formCompanyAddress.patchValue({
        CompanySubDistrictCode: address.CompanySubDistrictCode || null,
        CompanyPostCode: address.CompanyPostCode || null, // ถ้า PostCode ไม่ได้ถูกตั้งอัตโนมัติจาก LoadSubDistrictList
      });
    }, 0);

    $('#ModalCompanyAddressAddEdit').modal('show');
  }

  async btnClick_submitUpdateCompanyAddress(id) {
    this.markFormGroupTouched(this.formCompanyAddress);

    if (this.formCompanyAddress.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //this.OnUpdating('y');

        id = this.hidCompanyAddressID
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`

          })
        };

        const formValue = this.formCompanyAddress.value;

        var objectjson = {};
        objectjson['CompanyAddressID'] = id;
        objectjson['CompanyAddress'] = this.checkUndefinedString(formValue.CompanyAddress);
        objectjson['CompanyProvinceCode'] = this.checkUndefinedString(formValue.CompanyProvinceCode);
        objectjson['CompanyDistrictCode'] = this.checkUndefinedString(formValue.CompanyDistrictCode);
        objectjson['CompanySubDistrictCode'] = this.checkUndefinedString(formValue.CompanySubDistrictCode);
        objectjson['CompanyPostCode'] = this.checkUndefinedString(formValue.CompanyPostCode);
        objectjson['CompanyAddressCountryCode'] = this.checkUndefinedString(formValue.CompanyCountryCode);
        objectjson['CompanyAddressUpdateBy'] = this.checkUndefinedString(this._EmpCode);

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<CompanyAddressInfo[]>(this.baseurl + "Company/UpdateComnapyAddress", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            //this.OnUpdating('n');
          },
            async () => {
              console.log("Update = " + this.isSubmitted);
              //this.OnUpdating('n');
              $('#ModalCompanyAddressAddEdit').modal('hide');
              $('#ModalCompanyAddressAddEditComplete').modal();
              await this.LoadCompanyAddressList(this.hidCompanyIDForAddress);
            }
          )
      }
    } else {
      this.validateAllFormFields(this.formCompanyAddress);
    }
  }

  chkallCompanyAddressclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxcompanyAddress"]').prop('checked', check);
  }

  async btnClick_onDeleteCompanyAddressList() {
    if (confirm("Are you sure to delete this Company Address?")) {

      var checkkedcompanyaddress = $('[name="checkboxcompanyAddress"]:checked'); // checkkedcompanyconact
      let num = checkkedcompanyaddress.length;
      let listCompanyAddressModel = []; // listCompanyContactModel
      

      for (var i = 0; i < num; i++) {
        var CompanyAddresscurrent = <HTMLInputElement>checkkedcompanyaddress[i]; // CompanyContactcurrent
        let companyaddressInfo = new CompanyAddressInfo; // companycontactInfo
        companyaddressInfo.CompanyAddressID = parseInt(CompanyAddresscurrent.value); // currentCompanyContact

          var currentCompanyAddress = this.CompanyAddressList.filter(x => { return x.CompanyAddressID == companyaddressInfo.CompanyAddressID });
          var isOwner = (currentCompanyAddress[0].CompanyAddressCreateBy == this._EmpCode);

          console.log(" Delete id = " + companyaddressInfo.CompanyAddressID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
          if (isOwner || (this._RoleCode !== null && this._RoleCode !== "")) {
            listCompanyAddressModel.push(companyaddressInfo);
          } else
          {
            //this.titlemodal = ""
            //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
            this.detailmodal = "You don't have permission to delete this company. Please contact" + currentCompanyAddress[0].CompanyAddressCreateBy;
            $('#ModalError .modal-header').text("Information");
            $('#ModalError .modal-header').addClass('bg-blue');
            $('#ModalError').modal();

            listCompanyAddressModel = [];
            break; //break loop
          }
      }

      if (listCompanyAddressModel.length > 0) {
        this.deleteListCompanyAddress(listCompanyAddressModel)
      }

    }
  }

  async deleteListCompanyAddress(listCompanyAddressModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
     

      let strjsonCompAddressInfo = JSON.stringify(listCompanyAddressModel);

      this.httpClient.post<CompanyAddressInfo[]>(this.baseurl + "Company/DeleteListCompanyAddress", strjsonCompAddressInfo, httpOptions)
        .toPromise()
        .then(data => {
          console.log("delete company address list successfully");
          $('#ModalDeleteCompAddressComplete').modal('show');
          this.onModalClose();
          this.LoadCompanyAddressList(this.hidCompanyIDForAddress);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
  
  async LoadCountryList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        CountryCode: "TH" // Show Thailand Only for this step
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Country/GetCountry", JSON.stringify(objectjson), httpOptions).toPromise();
      this.CountryList = response;

      if(this.CountryList.length > 0){
        const firstCountryCode = this.CountryList[0].CountryCode;
        this.formCompanyAddress.patchValue({CompanyCountryCode: firstCountryCode});
      }
    } catch (error) {
      console.error('Error loading province:', error);
    } finally {
    }
  }

  onPrefixInput(event: any) {
    let value: string = event.target.value;
    // 1. Fix to UpperCase
    value = value.toUpperCase();
    // 2. Filter Uppder A–Z Only
    value = value.replace(/[^A-Z]/g, '');
    // 3. Fix Max Length 3 digit 
    if (value.length > 3) {
      value = value.substring(0, 3);
    }

    // Update into input & model
    event.target.value = value;
    this.CompanyPrefix = value;
    this.formCompanyGroup.get('CompanyPrefix')?.setValue(value, { emitEvent: false });
  }

}
  
  



  function alphabetically(ascending, colName) {

    return function (a, b) {

      // equal items sort equally
      if (a[colName] === b[colName]) {
        return 0;
      }
      // nulls sort after anything else
      else if (a[colName] === null) {
        return 1;
      }
      else if (b[colName] === null) {
        return -1;
      }
      // otherwise, if we're ascending, lowest sorts first
      else if (ascending) {
        return a[colName] < b[colName] ? -1 : 1;
      }
      // if descending, highest sorts first
      else {
        return a[colName] < b[colName] ? 1 : -1;
      }
    };
  }
